import { Component, OnDestroy, OnInit } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RouterFacade } from '@classifieds-sell/state';

@Component({
    selector: 'tm-feedback-email-button',
    templateUrl: './feedback-email-button.component.html',
    styleUrls: ['./feedback-email-button.component.scss'],
    standalone: false
})
export class FeedbackEmailButtonComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();
  public isFeedbackModalVisible = false;
  public categoryId: number;
  public subCategory: string;
  public step: string;
  public listingId: string;

  constructor(private _routerFacade: RouterFacade) { }

  ngOnInit(): void {
      this._routerFacade.categoryId$.pipe(
          take(1)
      ).subscribe(
          categoryId => {
              this.categoryId = categoryId;
          }
      );

      this._routerFacade.subCategory$.pipe(
          take(1),
          takeUntil(this._destroyed$)
      ).subscribe(
          subCategory => {
              this.subCategory = subCategory;
          }
      );

    this._routerFacade.routerData$.pipe(takeUntil(this._destroyed$))
      .subscribe(routerData => {
        this.step = routerData.stepInfo.stepId;
      }
    );

    this._routerFacade.listingId$.pipe(takeUntil(this._destroyed$))
      .subscribe(listingId => {
        this.listingId = listingId;
      }
    );
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
  }

  public onFeedbackClose() {
    this.isFeedbackModalVisible = false;
  }
}
